<template>
  <v-card>
    <v-card-subtitle>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('Search')"
        single-line
        hide-details
      />
    </v-card-subtitle>
    <v-data-table
      :headers="headers"
      :items="laboratories || []"
      :search="search"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      calculate-widths
      show-expand
      show-select
      item-key="id"
      :value="labsSelected"
      @input="onLabsSelect"
      @click:row="onClickOnLaboratory"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          :to="{name: 'LaboratoryView', params: {laboratoryId: item.id}}"
          target="_blank"
        >
          <v-icon
            small
          >
            mdi-open-in-new
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td
          class="cursor-auto"
          :colspan="headers.length"
        >
          <v-row>
            <v-col>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Manager</v-list-item-title>
                  <span v-if="item.manager">
                    {{ item.manager.firstName }} {{ item.manager.lastName }}
                  </span>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Address</v-list-item-title>
                  {{ item.address }}
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Telephone</v-list-item-title>
                  {{ item.telephone }}
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Central/Reference lab</v-list-item-title>
                  <template v-if="item.parentLaboratory">
                    {{ item.parentLaboratory.name }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Peripheral lab</v-list-item-title>
                  <template v-if="item.childLaboratories.length">
                    <span
                      v-for="(lab, index) in item.childLaboratories"
                      :key="lab.id"
                    >
                      <template v-if="index > 0">, </template>
                      {{ lab.name }}
                    </span>
                  </template>
                  <template v-else>
                    -
                  </template>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Scope of services</v-list-item-title>
                  <div class="d-flex flex-wrap">
                    <v-chip
                      v-for="service in levelOfServicesForDataTable(item)"
                      :key="service"
                      class="mr-1 my-1"
                    >
                      {{ service }}
                    </v-chip>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>

    export default {
        name: "LaboratoriesSelect",

        props: {
            laboratories: {
                type: Array,
                required: true
            },
            labsSelected: {
                type: Array,
                required: true
            }
        },

        data() {
            return {
                // labsSelected: [],
                sortBy: 'id',
                sortDesc: false,
                search: '',
            }
        },

        computed: {
            headers() {
                let headers = [
                    {
                        text: this.$t('Id'),
                        value: 'id',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Name'),
                        value: 'name',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Type'),
                        value: 'laboratoriesType.name',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Users'),
                        value: 'users.length',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: '',
                        value: 'actions',
                        align: 'end',
                        sortable: false,
                    },
                    {
                        text: '',
                        value: 'data-table-expand'
                    },
                ];

                headers.forEach(e => {
                    e.class = 'text-no-wrap'
                });

                return headers
            },
        },

        methods: {
            onLabsSelect(labs) {
                this.$emit('update:labsSelected', labs);
                // this.labsSelected = labs;
            },

            levelOfServicesForDataTable(lab) {
                return lab.levelOfServices ? lab.levelOfServices.split(', ') : []
            },

            onClickOnLaboratory(item) {
                let index = this.labsSelected.findIndex(e => e.id === item.id);
                if (index === -1) {
                    this.labsSelected.push(item)
                } else {
                    this.labsSelected.splice(index, 1)
                }
            }
        }

    }
</script>

<style lang="scss" scoped>
  .v-data-table {
    ::v-deep td {
      cursor: pointer;
    }
  }
</style>
